import React from 'react'
import "./Header.css";


const Applynow = () => {
  return (
    <div className="applynow">
        <h3>
          We’re Hiring – Find a wide range of open positions +{" "}
          <b> Apply Now »</b>
        </h3>
      </div>
  )
}

export default Applynow